import Actions                from 'Redux/Actions';
import { EmployeeRepository } from 'Domain/Repositories';
import { ofType }             from 'redux-observable';
import { from }               from 'rxjs';
import { mergeMap }           from 'rxjs/operators';
import { TEpic }              from 'Redux/Config';

export const searchEmployeesEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.searchEmployeesRequest.type),
    mergeMap(action => from(
      EmployeeRepository.findAll(action.payload)
        .then(({ employees, meta }) => Actions.searchEmployeesSuccess({ employees, maxCount: meta?.count }))
        .catch((error: Error) => Actions.searchEmployeesFailure({ error })),
    )),
  );
};
